import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

import App from './App.js';
import ArtificialIntelligence from './ArtificialIntelligence.js';
import WebAppDevelopment from './WebAppDevelopment.js';
import Blockchain from './Blockchain.js';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const routerX = createBrowserRouter([
  { path: '/', element: <App/>},
  { path: '/artificial-intelligence', element: <ArtificialIntelligence/>},
  { path: '/web-app-development', element: <WebAppDevelopment/>},
  { path: '/blockchain', element: <Blockchain/>},
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={routerX} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
